import { getUserIdentity } from "../../../common/helpers/authorizationHelper";
import GroupTitle from "./GroupTitle";

type Props = {
    netAmount: string;
    serviceCommissionRate: string;
    isShowCost: boolean;
    isWebPortal: boolean;
    currencySymbol?:string;
    serviceCommissionAmount?:string;
};

const CostArea = (props: Props) => {
    const { netAmount, serviceCommissionRate, isShowCost, isWebPortal, currencySymbol, serviceCommissionAmount } = props;
    if (!isWebPortal) {
        return null;
    }
    const userIdentity = getUserIdentity();
    const cleanAmount = netAmount.replace(/\./g, '').replace(',', '.');
    const numericAmount: number = Number(cleanAmount);
    const isAuthorized = userIdentity === "ADMIN" || userIdentity === "FİRMA YETKİLİSİ";
    const hasValidAmount = !isNaN(numericAmount) && numericAmount > 0;

    if (!isAuthorized || !hasValidAmount || !isShowCost) {
        return null;
    }

    return (
        <div className="w-full mt-6 bg-white ">
            <GroupTitle title="Ödeme Maliyeti" />
            <div className="h-20 rounded-lg flex items-center justify-between p-2 cursor-pointer rounded-lg">
                <div className="w-full pt-2">
                    <div className="flex justify-between items-center w-full">
                        <p className="text-sm text-contrast-90 font-medium">
                            Hizmet Komisyon Oranı:
                        </p>
                        <p className="text-sm text-contrast-90 font-bold">
                            % {serviceCommissionRate}
                        </p>
                    </div>
                    <div className="flex justify-between items-center w-full">
                        <p className="text-sm text-contrast-90 font-medium">
                            Hizmet Tutarı:
                        </p>
                        <p className="text-sm text-contrast-90 font-bold">
                            {serviceCommissionAmount} {currencySymbol}
                        </p>
                    </div>
                    <div className="flex justify-between items-center w-full">
                        <p className="text-sm text-contrast-90 font-medium">
                            Hesaba Geçecek Net Tutar:
                        </p>
                        <p className="text-sm text-contrast-90 font-bold">
                            {netAmount} {currencySymbol}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CostArea;